module.exports = __webpack_public_path__ + "img/160.60d7ab2b.jpg";